import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-large-right, chev right, next"} maskId="square-filled-radius-0-stroke-1-IconChevronLargeRight"><path fillRule="evenodd" clipRule="evenodd" d="M9.65555 1.81055L16.0912 12.0003L9.65555 22.19L8.81006 21.656L14.9084 12.0003L8.81006 2.34454L9.65555 1.81055Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronLargeRight;
